import { Component, OnInit } from '@angular/core';
import { AuthKeyService } from "../../services/auth-key.service";
import { ModalController } from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent, IonIcon } from "@ionic/angular/standalone";
import { DisplayService } from "@qid/core";
import { CommonModule } from '@angular/common';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent, SuperInputComponent } from '@qid/super';

@Component({
    selector: 'app-generate-key',
    templateUrl: './generate-key.component.html',
    styleUrls: ['./generate-key.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        SexyModule,
        SuperButtonComponent,
        SuperInputComponent,
        IonHeader,
        IonToolbar,
        IonButton,
        IonTitle,
        IonContent,
        IonIcon
    ]
})
export class GenerateKeyComponent implements OnInit {

    public keyName: string;
    public expiryDate: Date = new Date();
    public activeSlide: number = 0;
    public key: string;
    public tokenId: string;

    constructor(
        private authKeyService: AuthKeyService,
        private modalController: ModalController,
        private displayService: DisplayService,
    ) {
    }

    ngOnInit() {
    }

    close() {
        this.modalController.dismiss();
    }


    // create a function insert the provided text into a txt file and download it

    downloadTxtFile(text) {
        const element = document.createElement("a");
        const file = new Blob([text], { type: 'text/plain' });
        element.href = URL.createObjectURL(file);
        element.download = `qid_secret.txt`;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }


    generateKey = async () => {

        if (this.keyName == null || this.keyName == "") {
            throw "Key Name is required"
        }

        if (this.expiryDate == null) {
            throw "Expiry Date is required"
        }

        const res = await this.authKeyService.createKey(this.keyName, this.expiryDate);

        if (!res) {
            throw "Failed to create key"
        }


        if (res) {
            this.activeSlide = 1;
            this.tokenId = res.tokenId;
            return this.key = res.secret;
        }


    }


    saveKey = async () => {
        this.downloadTxtFile(this.key);
        await this.displayService.alert("Success", "The secret has been downloaded.")
        await this.modalController.dismiss("ModalClosed");
    }

    copyKeyToClipboard = () => {
        const el = document.createElement('textarea');
        el.value = this.key;
        document.body.appendChild(el);
        el.select();

        try {
            navigator.clipboard.writeText(this.key)
                .then(() => {
                    this.displayService.toast({ message: "The secret has been copied to your clipboard." });
                })
                .catch((error) => {
                    console.error('Error writing to clipboard:', error);
                });
        } finally {
            document.body.removeChild(el);
        }
    }
    copyIDToClipboard = () => {
        const el = document.createElement('textarea');
        el.value = this.tokenId;
        document.body.appendChild(el);
        el.select();

        try {
            navigator.clipboard.writeText(this.tokenId)
                .then(() => {
                    this.displayService.toast({ message: "The token ID has been copied to your clipboard." });
                })
                .catch((error) => {
                    console.error('Error writing to clipboard:', error);
                });
        } finally {
            document.body.removeChild(el);
        }
    }


}
